export const useUpdateDocumentTitle = () => {
  const updateDocumentTitle = (title: string) => {
    document.title = title
  }

  return {
    updateDocumentTitle
  }
}